import { ItemObject } from 'src/app/models/products/item/item-object.model';
import { Converter } from '../converter.interface';
import { Injectable } from '@angular/core';
import { TabObject } from 'src/app/models/products/item/tab-object.model';
import { TreeCardObject } from 'src/app/models/products/tree-card/tree-card-object.model';

@Injectable({
    providedIn: 'root'
})
export class ProductItemConverter implements Converter<ItemObject>{

    constructor() { }

    convert(input: TreeCardObject): ItemObject {
        return new ItemObject(input.getMapping(), input.getId(), input.getType(), TabObject.INFORMATION_TAB);
    }
}